import React from "react";
import { Link } from "react-router-dom";
import { homeForRole } from "../../store/actions/AuthActions";
import "./Error404.css";

/* 404: the number, one line, and the way home. Home is the reader's own
   dashboard -- a student's, a trainer's or the admin one -- the same answer
   /login redirects to. Colours follow the chosen palette. */
const Error404 = () => {
  const home = homeForRole(localStorage.getItem("userRole"));

  return (
    <main className="e404">
      <h1 className="e404-code">404</h1>
      <p className="e404-text">The page you are looking for does not exist.</p>
      <Link className="e404-btn" to={home}>
        Return
      </Link>
    </main>
  );
};

export default Error404;
